export const HOME = {
  emergentLink: "home-emergent-link",
};

export const HOME_TOOLS = {
  root: "home-tools-bento",
  tile: (key) => `home-tool-${key}`,
  samples: "home-card-samples",
  sample: (i) => `home-card-sample-${i}`,
};


export const NAV = {
  root: "site-header",
  logo: "nav-logo",
  tabHome: "nav-tab-home",
  tabTrees: "nav-tab-family-trees",
  tabTreesFeatured: "nav-tab-family-trees-featured",
  tabTreesBuilder: "nav-tab-family-trees-builder",
  tabCelebrate: "nav-tab-celebrate",
  tabCelebrateMemorials: "nav-tab-celebrate-memorials",
  tabFamous: "nav-tab-famous",
  tabExplore: "nav-tab-explore",
  tabHeritage: "nav-tab-heritage",
  tabCards: "nav-tab-cards",
  tabAbout: "nav-tab-about",
  tabContact: "nav-tab-contact",
  linkAbout: "nav-link-about",
  linkTrees: "nav-link-trees",
  linkHeritage: "nav-link-heritage",
  linkMemorials: "nav-link-memorials",
  ctaStart: "nav-cta-start",
  ctaLogin: "nav-cta-login",
  ctaLogout: "nav-cta-logout",
  userBadge: "nav-user-badge",
};

export const FAMOUS = {
  root: "famous-families-page",
  card: (id) => `famous-family-${id}`,
  wikiLink: (id) => `famous-wiki-${id}`,
  videoLink: (id) => `famous-video-${id}`,
  royalItem: (i) => `royal-house-${i}`,
};

export const PAGES = {
  about: "about-page",
  contact: "contact-page",
  explore: "explore-page",
  celebrate: "celebrate-page",
  familyTrees: "family-trees-page",
  heritage: "heritage-page",
  heritageTopic: "heritage-topic-page",
  heritageTopicContent: "heritage-topic-content",
  heritageTopicRefresh: "heritage-topic-refresh",
  heritageSection: (id) => `heritage-section-${id}`,
  heritageItem: (slug) => `heritage-item-${slug}`,
  contactForm: "contact-form",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  sub: "hero-subheadline",
  ctaStartTree: "hero-cta-start-tree",
  ctaSearchRecords: "hero-cta-search-records",
  ctaExploreHeritage: "hero-cta-explore-heritage",
  statTrees: "hero-stat-trees",
  statStates: "hero-stat-states",
  statMembers: "hero-stat-members",
};

export const MARQUEE = {
  root: "editorial-marquee",
};

export const MANIFESTO = {
  root: "manifesto-section",
  chapter: (i) => `manifesto-chapter-${i}`,
};

export const TREE_DEMO = {
  root: "tree-demo-section",
  node: (id) => `tree-node-${id}`,
  detail: "tree-node-detail",
};

export const FEATURED = {
  root: "featured-trees-section",
  card: (id) => `featured-tree-${id}`,
  viewAll: "featured-view-all",
};

export const GEO = {
  root: "geographic-browser",
  countrySelect: "geo-country-select",
  stateSelect: "geo-state-select",
  districtInput: "geo-district-input",
  submit: "geo-submit",
  result: "geo-result",
};

export const MEMORIALS = {
  root: "memorials-section",
  card: (id) => `memorial-card-${id}`,
  candleBtn: (id) => `memorial-candle-${id}`,
  candleCount: (id) => `memorial-candles-${id}`,
};

export const BENTO = {
  root: "collections-grid",
  tile: (i) => `collection-tile-${i}`,
};

export const MIGRATION = {
  root: "migration-section",
};

export const RECORDS = {
  root: "records-section",
  chip: (i) => `record-chip-${i}`,
};

export const CTA = {
  root: "final-cta",
  waitlistInput: "waitlist-input",
  waitlistSubmit: "waitlist-submit",
  ctaGetStarted: "cta-get-started",
};

export const FOOTER = {
  root: "site-footer",
};

export const AUTH = {
  dialog: "auth-dialog",
  tabLogin: "auth-tab-login",
  tabRegister: "auth-tab-register",
  email: "auth-email",
  password: "auth-password",
  name: "auth-name",
  submitLogin: "auth-submit-login",
  submitRegister: "auth-submit-register",
  error: "auth-error",
};

export const BUILDER = {
  page: "my-tree-page",
  loginPrompt: "my-tree-login-prompt",
  loginPromptBtn: "my-tree-login-prompt-btn",
  createFirstBtn: "my-tree-create-first",
  newTreeInput: "my-tree-new-name-input",
  newTreeSubmit: "my-tree-new-submit",
  treeSelector: "my-tree-selector",
  renameBtn: "my-tree-rename",
  deleteTreeBtn: "my-tree-delete",
  canvas: "my-tree-canvas",
  personNode: (id) => `my-tree-node-${id}`,
  addFirstPerson: "my-tree-add-first-person",
  toolbarAdd: "my-tree-toolbar-add",
  personDialog: "my-tree-person-dialog",
  personName: "my-tree-person-name",
  personBirth: "my-tree-person-birth",
  personDeath: "my-tree-person-death",
  personPlace: "my-tree-person-place",
  personPortrait: "my-tree-person-portrait",
  personNotes: "my-tree-person-notes",
  personGender: "my-tree-person-gender",
  personIsYou: "my-tree-person-is-you",
  personSave: "my-tree-person-save",
  personDelete: "my-tree-person-delete",
  addChildBtn: "my-tree-add-child",
  addParentBtn: "my-tree-add-parent",
  addSpouseBtn: "my-tree-add-spouse",
  linkPickerDialog: "my-tree-link-picker",
  linkPickerOption: (id) => `my-tree-link-option-${id}`,
};


export const PORTRAITS = {
  page: "my-portraits-page",
  loginPrompt: "portraits-login-prompt",
  uploadInput: "portraits-upload-input",
  uploadBtn: "portraits-upload-btn",
  grid: "portraits-grid",
  card: (id) => `portrait-${id}`,
  deleteBtn: (id) => `portrait-delete-${id}`,
};

export const CARDS = {
  page: "card-studio-page",
  loginPrompt: "cards-login-prompt",
  samplesStrip: "cards-samples-strip",
  sampleCard: (i) => `cards-sample-${i}`,
  sampleApplyBtn: (i) => `cards-sample-apply-${i}`,
  publishSelect: "cards-publish-select",
  saveBtn: "cards-save-btn",
  uploadTab: "cards-upload-tab",
  uploadFile: "cards-upload-file",
  uploadSubmit: "cards-upload-submit",
  occasionGrid: "cards-occasion-grid",
  occasionPill: (id) => `cards-occasion-${id}`,
  personName: "cards-person-name",
  dates: "cards-dates",
  topText: "cards-top-text",
  bottomText: "cards-bottom-text",
  aiSuggestTop: "cards-ai-suggest-top",
  aiSuggestBottom: "cards-ai-suggest-bottom",
  variantPicker: "cards-variant-picker",
  variantOption: (i) => `cards-variant-${i}`,
  portraitPicker: "cards-portrait-picker",
  portraitOption: (id) => `cards-portrait-option-${id}`,
  portraitUpload: "cards-portrait-upload",
  preview: "cards-preview",
  refreshPreview: "cards-refresh-preview",
  download: "cards-download",
  format: "cards-format",
};

export const MY_CARDS = {
  page: "my-cards-page",
  grid: "my-cards-grid",
  card: (id) => `my-card-${id}`,
  publish: (id) => `my-card-publish-${id}`,
  unpublish: (id) => `my-card-unpublish-${id}`,
  remove: (id) => `my-card-remove-${id}`,
  uploadBtn: "my-cards-upload-btn",
};

export const FEED = {
  page: "feed-page",
  indexPage: "feed-index-page",
  card: (id) => `feed-card-${id}`,
  occasionLink: (o) => `feed-occasion-${o}`,
};